// extracted by mini-css-extract-plugin
module.exports = {"CategoryCard":"style_CategoryCard__2pXUV","CategoryCard_selected":"style_CategoryCard_selected__1dWZI","Label":"style_Label__23FEj","Icon":"style_Icon__2LXUN"};